import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe91cc28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Back to Home")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($setup.ready)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        ($setup.success)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Payment Succeeded!"))
          : (_openBlock(), _createElementBlock("h1", _hoisted_2, "Issue with Payment")),
        _createElementVNode("p", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1 /* STABLE */
          })
        ])
      ], 64 /* STABLE_FRAGMENT */))
    : _createCommentVNode("v-if", true)
}